/**
 * Utilidades para formateo de fechas
 * Centraliza la lógica de conversión de formatos de fecha
 */

/**
 * Formatea una fecha de formato 'YYYY-MM-DD' a 'DD/MM/YYYY'
 * @param dateStr - Fecha en formato ISO (YYYY-MM-DD)
 * @returns Fecha en formato DD/MM/YYYY
 */
export function formatDateForSubmit(dateStr: string): string {
  if (!dateStr) return '';

  try {
    const [year, month, day] = dateStr.split('-');
    // El mes en Date es base 0
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    const dayStr = date.getDate().toString().padStart(2, '0');
    const monthStr = (date.getMonth() + 1).toString().padStart(2, '0');
    const yearStr = date.getFullYear();
    const formatted = `${dayStr}/${monthStr}/${yearStr}`;
    console.log('📅 Fecha formateada para submit:', formatted);
    return formatted;
  } catch (error) {
    console.error('❌ Error formateando fecha:', dateStr, error);
    return '';
  }
}

/**
 * Convierte una fecha de formato 'DD/MM/YYYY' a 'YYYY-MM-DD'
 * @param dateStr - Fecha en formato DD/MM/YYYY
 * @returns Fecha en formato ISO (YYYY-MM-DD)
 */
export function formatDateFromSubmit(dateStr: string): string {
  if (!dateStr) return '';

  try {
    if (dateStr.includes('/')) {
      const [day, month, year] = dateStr.split('/');
      const formatted = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      console.log('📅 Fecha formateada desde submit:', formatted);
      return formatted;
    }
    return dateStr;
  } catch (error) {
    console.error('❌ Error formateando fecha desde submit:', dateStr, error);
    return '';
  }
}

/**
 * Formatea una fecha del orquestador al formato del input HTML
 * @param dateStr - Fecha que puede venir en DD/MM/YYYY o YYYY-MM-DD
 * @returns Fecha en formato YYYY-MM-DD para input type="date"
 */
export function formatDateForInput(dateStr: string): string {
  if (!dateStr) return '';

  try {
    // Si viene en formato DD/MM/YYYY, convertir a YYYY-MM-DD
    if (dateStr.includes('/')) {
      return formatDateFromSubmit(dateStr);
    }
    // Si ya viene en formato YYYY-MM-DD, devolverlo tal cual
    return dateStr;
  } catch (error) {
    console.error('❌ Error formateando fecha para input:', dateStr, error);
    return '';
  }
}

/**
 * Obtiene la fecha actual en formato ISO (YYYY-MM-DD)
 * @returns Fecha actual en formato YYYY-MM-DD
 */
export function getTodayISO(): string {
  return new Date().toISOString().split('T')[0];
}

/**
 * Calcula una fecha futura sumando días a la fecha actual
 * @param days - Número de días a sumar
 * @returns Fecha futura en formato YYYY-MM-DD
 */
export function getFutureDateISO(days: number): string {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date.toISOString().split('T')[0];
}
